import React, { useContext, useCallback, useEffect } from 'react';
import {
  Button,
  Icon,
  Link,
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
} from '@mui/material';
import { useLocation } from 'react-router';
import { useQRCode } from 'next-qrcode';
import config from '../../utils/config';
import toast from 'react-hot-toast';
import AppContext from '../../utils/app-context';
import { useNavigate } from 'react-router';

const useStyles = () => ({
  qrCode: {
    border: '0px solid #eee',
    marginBottom: '10px',
    width: '100%',
    maxWidth: '280px',
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: '20px',
    marginRight: 0,
    textAlign: 'left',
    width: '100%',
    maxWidth: '420px',
  },
  successStyles: {
    position: 'absolute',
    bottom: '-20px',
    left: '0px',
    fontSize: '9px',
    lineHeight: '12px',
    textTransform: 'lowercase',
    transition: '.5s all',
  }
});

const ShareDialog = (props) => {
  const classes = useStyles();
  const app_url = config.app_url;
  const loc = useLocation();
  const navigate = useNavigate();
  const { open, toggleShare } = props;
  const link = app_url + loc.pathname;
  const [showSuccess, setShowSuccess] = React.useState(false);
  const { state, dispatch } = useContext(AppContext);
  const { Canvas } = useQRCode();
  const isStoryOwner = state.app.userIsStoryOwner;
  const [settings, setSettings] = React.useState({});
  const [requirePassChecked, setRequirePassChecked] = React.useState(state.app.portal?.requirePass ? true : false);
  const [requirePass, setRequirePass] = React.useState(state.app.portal?.requirePass);
  const isTool = loc.pathname.indexOf('/t/') === 0 ? true : false;


  const defaultSettings = {
    communityCanUpload: true,
    communityCanCamera: true,
    communityCanVeneer: true,
    //communityCanShare: true,
    communityCanForkWithMedia: false
  };

  useEffect(() => {
    // console.log("portal", state.app.portal)
    // console.log("require pass", state.app.portal?.requirePass, requirePass, requirePassChecked);
  }, []);

  useEffect(() => {
    setSettings({ ...defaultSettings, ...state.app.settings });
  }, [state.app.settings]);

  /*useEffect(() => {
    setRequirePassChecked(state.app.portal?.requirePass ? true : false);
  }, [state.app.portal?.requirePass]);*/

  const handleClose = () => {
    toggleShare(false);
  };

  const copyLink = (text) => {
    navigator.clipboard.writeText(text);
    setShowSuccess(true);

    toggleShare(false);
    toast.success('Link Copied');

  };

  const updateSetting = (new_settings) => {
    dispatch({ type: 'UPDATE_STORY_SETTINGS', payload: { settings: new_settings, new: true } });
    setSettings(new_settings);
  };

  const handlePassChange = useCallback(
    (event) => {
      const value = event.target.value === '' ? null : event.target.value;
      setRequirePass(value);
      dispatch({ type: 'UPDATE_PORTAL_PASS', payload: { portal: state.app.portal, requirePass: value } });
    },
    [dispatch, state.app.portal]
  );

  const createPass = () => {
    const digits = '0123456789';
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';

    // Generate the 4 digits
    for (let i = 0; i < 4; i++) {
      const randomIndex = Math.floor(Math.random() * digits.length);
      result += digits[randomIndex];
    }

    // Generate the 2 letters
    for (let i = 0; i < 2; i++) {
      const randomIndex = Math.floor(Math.random() * letters.length);
      result += letters[randomIndex];
    }

    return result;
  }

  const handleCheckboxChange = useCallback(
    (event) => {
      const { name, checked } = event.target;
      let newSettings = { ...settings };
      // let updatePass = false;
      let newPass = null;
      switch (name) {
        case 'addMedia':
          newSettings.communityCanUpload = checked;
          newSettings.communityCanCamera = checked;
          break;
        case 'generateMedia':
          newSettings.communityCanVeneer = checked;
          break;
        /*case 'shareTheStory':
          newSettings.communityCanShare = checked;
          break;*/
        case 'forkTheStory':
          newSettings.communityCanForkWithMedia = checked;
          break;
        case 'addPass':
          setRequirePassChecked(checked);
          newPass = checked ? createPass() : null;
          if (!state.app.portal?.id) return;
          dispatch({ type: 'UPDATE_PORTAL_PASS', payload: { portal: state.app.portal, requirePass: newPass } });
          if (newPass) setRequirePass(newPass);
          break;
        case 'downloadTakes':
          newSettings.communityCanDownloadTakes = checked;
          break;
        default:
          break;
      }
      updateSetting(newSettings);
    },
    [settings, dispatch]
  );

  const handleMediaAction = () => {
    if (settings.communityCanUpload || settings.communityCanCamera) {
      toast.error('Media upload or camera access is disabled.');
      return;
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            backgroundColor: '#FFFFFF !important',
            color: '#272727 !important',
            borderRadius: '8px',
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            color: '#272727 !important',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span style={{ color: '#272727', fontWeight: 700 }}>Share</span>
          <Icon name="close" onClick={handleClose} aria-label="Close dialog" sx={{ color: '#272727 !important', cursor: 'pointer' }} />
        </DialogTitle>
        <DialogContent
          sx={{ maxWidth: 700, maxHeight: '90vh', overflowY: 'hidden', color: '#272727 !important' }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: isStoryOwner && !isTool ? { xs: 'column', sm: 'row' } : { xs: 'column' },
              alignItems: 'center',
              textAlign: { xs: 'center', sm: 'left' },
              '@media (max-width: 650px)': {
                flexDirection: 'column',
              },
            }}
          >
            <Box
              className={classes.qrCode}
              sx={{
                margin: '0 auto',
                mb: { xs: '16px', sm: '20px' },
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: '#FFFFFF',
              }}
            >
              <Canvas
                text={link}
                options={{
                  type: 'image/jpeg',
                  quality: 0.3,
                  level: 'H',
                  margin: 1,
                  scale: 4,
                  width: 280,
                }}
              />
            </Box>

            <Box
              className={classes.checkboxContainer}
              sx={{
                marginTop: { xs: 0, sm: 0 },
                textAlign: { xs: 'left', sm: 'left' },
                color: '#272727 !important',
                '@media (max-width: 650px)': {
                  marginLeft: 0,
                },
              }}
            >
              {isStoryOwner && !isTool && (
                <>
                  <DialogContentText
                    id="alert-dialog-description"
                    sx={{ fontWeight: 'bold', fontSize: { xs: '18px', sm: '20px' }, marginTop: '0px', color: '#272727 !important' }}
                  >
                    Anyone with this link can:
                  </DialogContentText>
                  <Box
                    sx={{
                      '& .MuiFormControlLabel-root': { color: '#272727 !important' },
                      '& .MuiCheckbox-root': {
                        color: '#4B5260 !important',
                        '&.Mui-checked': { color: '#272727 !important' },
                      },
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="addMedia"
                          checked={settings.communityCanUpload}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Add Media"
                    /><br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="generateMedia"
                          checked={settings.communityCanVeneer}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Generate Media"
                    /><br />
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="addPass"
                            checked={requirePassChecked || false}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Require Password to View"
                      />
                      {requirePassChecked && <OutlinedInput
                        type="text"
                        name="password"
                        value={requirePass || ""}
                        onChange={handlePassChange}
                        placeholder="Enter password"
                        fullWidth
                        margin="dense"
                        sx={{
                          backgroundColor: '#FFFFFF',
                          color: '#272727 !important',
                          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D1D5DB !important' },
                          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#9CA3AF !important' },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#272727 !important' },
                          input: { color: '#272727 !important' },
                        }}
                      />}
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="forkTheStory"
                          checked={settings.communityCanForkWithMedia}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Fork The Story"
                    /><br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="downloadTakes"
                          checked={settings.communityCanDownloadTakes}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Download Individual Assets"
                    />
                  </Box>
                </>
              )}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                }}
              >
                <Button
                  onClick={() => copyLink(link)}
                  variant="contained"
                  sx={{
                    marginTop: '10px',
                    display: { xs: 'block', sm: 'inline-block' },
                    backgroundColor: '#272727 !important',
                    color: '#FFFFFF !important',
                    border: 'none !important',
                    borderRadius: '6px',
                    padding: '8px 20px',
                    fontWeight: 600,
                    '&:hover': {
                      backgroundColor: '#3C3C3C !important',
                    },
                  }}
                >
                  COPY LINK
                </Button>
              </Box>
              {showSuccess && (
                <Box className="copy-success" sx={{ ...classes.successStyles, color: '#272727' }}>
                  Link Copied!
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default ShareDialog;